import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "loading_layer",
  ref: "kekse"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "bars1" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div id=\"modal_help\" class=\"modal fade\" tabindex=\"-1\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><h5 class=\"modal-title\">Basic modal</h5><button type=\"button\" class=\"close\" data-dismiss=\"modal\">×</button></div><div class=\"modal-body\"><h6 class=\"font-weight-semibold\">Text in a modal</h6><p>Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p><hr><h6 class=\"font-weight-semibold\">Another paragraph</h6><p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p><p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-link\" data-dismiss=\"modal\">Close</button><button type=\"button\" class=\"btn btn-primary\">Save changes</button></div></div></div></div>", 1)
const _hoisted_5 = { class: "content-wrapper" }
const _hoisted_6 = {
  key: 0,
  class: "breadcrumb-line breadcrumb-line-light header-elements-lg-inline"
}
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = { class: "breadcrumb" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "icon-chevron-left" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" zurück")
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "icon-home" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "d-none" }
const _hoisted_16 = {
  key: 1,
  class: "breadcrumb-item active"
}
const _hoisted_17 = { class: "d-none" }
const _hoisted_18 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _hoisted_3, 512),
    (_ctx.user.accessToken !== '')
      ? (_openBlock(), _createBlock(_component_Navbar, {
          key: 0,
          accounts: _ctx.accounts,
          onAccountChanged: _ctx.reloadAccounts
        }, null, 8, ["accounts", "onAccountChanged"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["page-content", {'pt-0':!_ctx.user.accessToken}])
    }, [
      _hoisted_4,
      _createVNode(_Transition, {
        name: "test",
        mode: "out-in",
        appear: ""
      }, {
        default: _withCtx(() => [
          (_ctx.user.accessToken !== '')
            ? (_openBlock(), _createBlock(_component_Sidebar, {
                key: 0,
                accounts: _ctx.accounts,
                onAccountChanged: _ctx.reloadAccounts
              }, null, 8, ["accounts", "onAccountChanged"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.breadcrumbs.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("a", {
                    class: "breadcrumb-item",
                    href: "",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.back()), ["prevent"]))
                  }, _hoisted_11),
                  _createElementVNode("a", {
                    class: "breadcrumb-item",
                    href: "",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.jumpBackToView('Dashboard')), ["prevent"]))
                  }, _hoisted_13),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (crump, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (!crump.active)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: "",
                            class: "breadcrumb-item",
                            onClick: _withModifiers(($event: any) => (_ctx.jumpBackToView(crump.view)), ["prevent"])
                          }, [
                            _createTextVNode(_toDisplayString(crump.name) + " ", 1),
                            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$route.params[crump.param]), 1)
                          ], 8, _hoisted_14))
                        : (_openBlock(), _createElementBlock("span", _hoisted_16, [
                            _createTextVNode(_toDisplayString(crump.name) + " ", 1),
                            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$route.params[crump.param]), 1)
                          ]))
                    ], 64))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component }) => [
              _createVNode(_Transition, {
                name: _ctx.transitionName,
                mode: _ctx.transitionMode,
                appear: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                ]),
                _: 2
              }, 1032, ["name", "mode"])
            ]),
            _: 1
          })
        ])
      ])
    ], 2)
  ], 64))
}